module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../../src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = styles